import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-line\"><path d=\"M130.1 223.7l833.2 481c32.9 19 44.1 61 25.2 93.9s-61 44.1-93.9 25.2l-833.2-481c-32.9-19-44.1-61-25.2-93.9 19-32.9 61-44.1 93.9-25.2z\" p-id=\"13435\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol